import * as d3 from "d3";
import { parseSvg } from "d3-interpolate/src/transform/parse";
import { useEffect } from "react";

const Drag = ({ x, effect ,dragCallback }) => {
    useEffect(() => {
        var max_value, flip, offset;

        const drag = d3
            .drag()
            .subject(function (event, track) {
                offset = x(track["offset"]);
                max_value = Math.max(
                    ...d3
                        .select(this)
                        .datum()
                        ["genes"].map((protein) => {
                            return protein["end"];
                        })
                );
                flip = d3.select(this).classed("flip");
                const me = d3.select(this);

                // var curHtml = d3.select(this).node().parentNode


                // if(label_trans === 0){
                //     label_trans = d3.select(curHtml).select('.labels').attr('transform')
                //     label_trans = parseFloat(label_trans.slice(label_trans.indexOf('(')+1,label_trans.indexOf(',')))
                //
                // }

                // var curTrans = me.attr('transform')
                // curTrans = parseFloat(curTrans.slice(curTrans.indexOf('(')+1,curTrans.indexOf(',')))
                return { x: me.attr("x") };
                //return { x: curTrans };
            })
            .on('start',function (event,d){
                if(event.sourceEvent.button !== 0) {
                    // console.log("not left click");
                    return;
                }

                d3.selectAll('.genomes').style('cursor','grab')
            })
            .on("drag", function (event, track) {
                if(event.sourceEvent.button !== 0) {
                    // console.log("not left click");
                    return;
                }


                d3.selectAll('.genomes').style('cursor','grabbing')

                var scaleX = parseSvg(d3.select(this).attr("transform"))[
                    "scaleX"
                ];

                var labelTrans = d3.select('.labels').attr('transform')
                labelTrans = parseFloat(labelTrans.slice(labelTrans.indexOf('(')+1,labelTrans.indexOf(',')))
                var taxTrans =  parseFloat(d3.select('.taxonomyBox').attr('x'))
                var bound = labelTrans + taxTrans

                var curHtml = d3.select(this).node().parentNode
                if (flip) {


                    // d3.select(this).attr(
                    //     "transform",
                    //     `translate(${Math.max(
                    //         x(max_value),
                    //         event.x
                    //     )},0) scale(${scaleX}, 1)`
                    // );

                    // if(x(max_value) > event.x){
                    //     d3.select(curHtml).select('.labels').style('opacity',0.5)
                    // }
                    // else{
                    //     d3.select(curHtml).select('.labels').style('opacity',1.0)
                    // }
                    var tmp = d3.select(curHtml)
                        .selectAll('.proteins').nodes()

                    var genomeTrans = d3.select(curHtml).select('.genomes').attr('transform')
                    genomeTrans = parseFloat(genomeTrans.slice(genomeTrans.indexOf('(')+1,genomeTrans.indexOf(',')))

                    tmp
                        .map((curRect)=>{
                            // console.log(curRect)
                            var leftBound = (curRect.points)[2].x
                            leftBound =  genomeTrans - leftBound

                            // if(leftBound <= 0){
                            //     // console.log(d3.select(curRect).style('storke-width'))
                            //     if(d3.select(curRect).style('stroke-width') === null){
                            //         d3.select(curRect).style('stroke-width',0.0)
                            //     }
                            // }else{
                            //     d3.select(curRect).style('stroke-width',strokeWidth)
                            // }


                            if(leftBound < bound){
                                d3.select(curRect).attr('opacity',0.0)
                            }
                            else{
                                d3.select(curRect).attr('opacity',0.5)
                            }
                            // console.log(curRect)
                            // console.log(leftBound,bound)
                            return curRect;
                        })

                    d3.select(this).attr(
                        "transform",
                        `translate(${
                            event.x
                        },0) scale(${scaleX}, 1)`
                    );
                    // var curHtml = d3.select(this).node().parentNode
                    // d3.select(curHtml).select('.labels').attr(
                    //     "transform",
                    //     `translate(${Math.min(label_trans,event.x+label_trans)},0) scale(${Math.abs(scaleX)}, 1)`
                    // );
                } else {


                    d3.select(this).attr(
                        "transform",
                        `translate(${
                            event.x
                        },0) scale(${scaleX}, 1)`
                    );

                    // var threshold = -10 + event
                    //console.log(event.x)

                    // console.log(d3.select(curHtml)
                    //     .selectAll('.proteins'))
                    var tmp = d3.select(curHtml)
                        .selectAll('.proteins').nodes()

                    var genomeTrans = d3.select(curHtml).select('.genomes').attr('transform')
                    genomeTrans = parseFloat(genomeTrans.slice(genomeTrans.indexOf('(')+1,genomeTrans.indexOf(',')))


                    // var tmp1 = tmp
                    //     .filter((curRect)=>{
                    //         var leftBound = (curRect.points)[0].x
                    //         leftBound = leftBound + genomeTrans
                    //         // console.log(leftBound,bound)
                    //         return leftBound < bound;
                    //     })
                    //
                    //
                    // if(tmp1.length > 0){
                    //     tmp1.map(node=>{
                    //         // console.log(node)
                    //         d3.select(node).attr('opacity',0.0)
                    //         // if(d3.select(node).style('stroke-width'))
                    //     })
                    // }
                    tmp
                    .map((curRect)=>{
                        // console.log(curRect)
                        var leftBound = (curRect.points)[0].x
                        leftBound = leftBound + genomeTrans

                        // if(leftBound <= 0){
                        //     // console.log(d3.select(curRect).style('storke-width'))
                        //
                        //     if(d3.select(curRect).style('stroke-width')){
                        //         d3.select(curRect).style('stroke-width',0.0)
                        //     }
                        // }else{
                        //     d3.select(curRect).style('stroke-width',strokeWidth)
                        // }

                        if(leftBound < bound){
                            d3.select(curRect).attr('opacity',0.0)
                        }
                        else{
                            d3.select(curRect).attr('opacity',0.5)
                        }
                        // console.log(curRect)
                        // console.log(leftBound,bound)
                        return curRect;
                    })


                    // if(tmp1.length > 0){
                    //     tmp1.map(node=>{
                    //         // console.log(node)
                    //         d3.select(node).attr('opacity',0.0)
                    //         // if(d3.select(node).style('stroke-width'))
                    //     })
                    // }

                    // console.log(tmp)


                        // .filter((curRect)=>{
                        //
                        //     console.log(curRect)
                        //     return true
                        // })
                        // .style('opacity',0)

                    // var tmp = d3.select(this).select('.proteins').node().points[0].x
                    //console.log(tmp)
                    // if(offset > event.x){
                    //     d3.select(curHtml).select('.labels').style('opacity',0.5)
                    // }
                    // else{
                    //     d3.select(curHtml).select('.labels').style('opacity',1.0)
                    // }



                    // d3.select(this).attr(
                    //     "transform",
                    //     `translate(${
                    //         event.x
                    //     },0) scale(${scaleX}, 1)`
                    // );
                    // var curHtml = d3.select(this).node().parentNode
                    // d3.select(curHtml).select('.labels').attr(
                    //     "transform",
                    //     `translate(${Math.min(label_trans,event.x+label_trans)},0) scale(${scaleX}, 1)`
                    // );
                }
            })
            .on("end", function (event, track) {
                if(event.sourceEvent.button !== 0) {
                    // console.log("not left click");
                    return;
                }
                d3.selectAll('.genomes').style('cursor','grab')
                if (flip) {
                    // d3.select(this).attr("x", Math.max(x(max_value), event.x));
                    d3.select(this).attr("x",  event.x);
                    // track["x"] = Math.max(0, event.x);
                } else {
                    // d3.select(this).attr("x", Math.max(offset, event.x));
                    d3.select(this).attr("x",  event.x);
                    // track["x"] = Math.max(0, event.x);
                }


                let offsetX = event.x
                let curOrder = track['order']
                let orientation = track['flip']
                dragCallback(offsetX, curOrder, orientation)
            });

        d3.selectAll(".genomes").call(drag).style('cursor','grab');
    }, [effect]);
};

export default Drag;
